import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

type DataType = 'html' | 'style' | 'script' | 'url' | 'resource-url';

enum Data {
  Html = 'html',
  Style = 'style',
  Script = 'script',
  Url = 'url',
  ResourceUrl = 'resource-url',
}

@Pipe({
  name: 'safe',
  standalone: false,
})
@Injectable()
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: any, type: DataType): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case Data.Html:
        return this.domSanitizer.bypassSecurityTrustHtml(value || '');
      case Data.Style:
        return this.domSanitizer.bypassSecurityTrustStyle(value || '');
      case Data.Script:
        return this.domSanitizer.bypassSecurityTrustScript(value || '');
      case Data.Url:
        return this.domSanitizer.bypassSecurityTrustUrl(value || '');
      case Data.ResourceUrl:
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value || '');
    }
  }
}
